import { render } from "./NotificationBellComponent.vue?vue&type=template&id=25a68f28&scoped=true"
import script from "./NotificationBellComponent.vue?vue&type=script&lang=js"
export * from "./NotificationBellComponent.vue?vue&type=script&lang=js"

import "./NotificationBellComponent.vue?vue&type=style&index=0&id=25a68f28&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25a68f28"]])

export default __exports__